import { render, staticRenderFns } from "./ArrowupIcon.vue?vue&type=template&id=09886624&scoped=true"
var script = {}
import style0 from "./ArrowupIcon.vue?vue&type=style&index=0&id=09886624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09886624",
  null
  
)

export default component.exports